import React from 'react';
import { Assistant } from '@/types';
import { SuggestedPrompts } from '@/components/assistant';

interface EmptyStateProps {
    assistant: Assistant;
    onPromptClick: (prompt: string) => void;
    compact?: boolean;
}

export const EmptyState: React.FC<EmptyStateProps> = ({ assistant, onPromptClick, compact = false }) => {
    return (
        <div className={`flex flex-col items-center ${compact ? 'justify-start pt-10 sm:pt-12' : 'justify-center min-h-[40vh] sm:min-h-[50vh]'} animate-fade-in w-full`}>
            <div className="w-full text-center mb-8 sm:mb-10 md:mb-12">
                <h2 className="text-lg sm:text-xl md:text-2xl font-bold text-white mb-1">
                    Hi, I'm {assistant.name}
                </h2>
                {import.meta.env.VITE_WELCOME_TAGLINE && (
                    <p className="text-white font-semibold text-sm sm:text-base md:text-lg mt-1">
                        {import.meta.env.VITE_WELCOME_TAGLINE}
                    </p>
                )}
                {import.meta.env.VITE_WELCOME_TAGLINE ? (
                    <p className="text-gray-300 text-xs sm:text-sm md:text-base mt-1">
                        {import.meta.env.VITE_WELCOME_DESCRIPTION}
                    </p>
                ) : (
                    <p className="text-gray-300 text-sm sm:text-base md:text-lg mt-1">
                        {assistant.description}. How can I help you today?
                    </p>
                )}
            </div>

            <SuggestedPrompts
                prompts={assistant.suggestedPrompts}
                assistant={assistant}
                onPromptClick={onPromptClick}
            />
        </div>
    );
};